/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface ICookieComplianceDeclineButton {
    declineCookiesButtonText?: string;
    declineCookiesButtonAriaLabel?: string;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onClose(): void;
}

export const CookieComplianceDeclineButton: React.FC<ICookieComplianceDeclineButton> = ({
    declineCookiesButtonText,
    declineCookiesButtonAriaLabel,
    telemetryContent,
    onClose
}) => {
    const payLoad: IPayLoad = getPayloadObject('click', telemetryContent!, 'decline cookies');
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <button
            type='button'
            className='ms-cookie-compliance__decline-button msc-btn'
            aria-label={declineCookiesButtonAriaLabel}
            onClick={onClose}
            {...attributes}
        >
            {declineCookiesButtonText}
        </button>
    );
};
